import svg4everybody from 'svg4everybody';
import $ from 'jquery';

$(() => {
	svg4everybody();
});

import Layout from '../layouts/default/default';
import Navigation from '../blocks/navigation/navigation';
import Popup from '../blocks/popup/popup';
import Info from '../blocks/info/info';

import Field from '../blocks/field/field';
import Change from '../blocks/change/change';
import Auth from '../blocks/auth/auth';
import Board from '../blocks/board/board';
import FinalScene from '../blocks/final-scene/final-scene';



$(() => new Layout().render());
$(() => new Navigation().render());
$(() => new Popup().render());
$(() => new Info().render());

$(() => new Field().render());
$(() => new Change().render());
$(() => new Auth().render());
$(() => new Board().render());
$(() => new FinalScene().render());


// WEBPACK FOOTER //
// ./app/scripts/app.js